"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessUnitsDetails = exports.businessUnitToDomain = exports.businessUnitToEnv = exports.CurrentBrandEnv = exports.logosName = exports.allBrands = void 0;
const types_1 = require("../../types");
const images_1 = require("../images");
exports.allBrands = ['boticario', 'oui', 'euamomake', 'eudora'];
exports.logosName = {
    euamomakeLogo: images_1.eamLogo,
    euamomakeLogoWhite: images_1.eamLogoWhite,
    boticarioLogo: images_1.boticarioLogoGreen,
    boticarioLogoWhite: images_1.boticarioLogo,
    eudoraLogo: images_1.eudoraLogoBack,
    eudoraLogoWhite: images_1.eudoraLogoWhite,
    eudoraLogoDark: images_1.eudoraLogo,
    ouiLogo: images_1.ouiLogo,
    ouiLogoWhite: images_1.ouiLogoWhite,
};
var CurrentBrandEnv;
(function (CurrentBrandEnv) {
    CurrentBrandEnv["BOT"] = "BOT";
    CurrentBrandEnv["EUD"] = "EUD";
    CurrentBrandEnv["OUI"] = "OUI";
    CurrentBrandEnv["EAM"] = "EAM";
    CurrentBrandEnv["MLT"] = "MLT";
})(CurrentBrandEnv = exports.CurrentBrandEnv || (exports.CurrentBrandEnv = {}));
exports.businessUnitToEnv = {
    [types_1.BusinessUnit.BOT]: CurrentBrandEnv.BOT,
    [types_1.BusinessUnit.EAM]: CurrentBrandEnv.EAM,
    [types_1.BusinessUnit.EUD]: CurrentBrandEnv.EUD,
    [types_1.BusinessUnit.OUI]: CurrentBrandEnv.OUI,
    [types_1.BusinessUnit.MLT]: CurrentBrandEnv.MLT,
};
exports.businessUnitToDomain = {
    [types_1.BusinessUnit.BOT]: 'boticario.com.br',
    [types_1.BusinessUnit.EUD]: 'eudora.com.br',
    [types_1.BusinessUnit.EAM]: 'quemdisseberenice.com.br',
    [types_1.BusinessUnit.OUI]: 'ouiparis.com',
    [types_1.BusinessUnit.MLT]: 'multimarcas.grupoboticario.com.br',
};
exports.businessUnitsDetails = [
    { bu: types_1.BusinessUnit.BOT, title: 'O Boticário' },
    { bu: types_1.BusinessUnit.EUD, title: 'Eudora' },
    { bu: types_1.BusinessUnit.EAM, title: 'Quem disse, Berenice?' },
    { bu: types_1.BusinessUnit.OUI, title: 'O.U.i' },
];
